"use strict";

angular.module("core")
.component("orderRevisionsWarning", {
    templateUrl: require("./order-revisions-warning.component.html"),
    css: [require("./order-revisions-warning.useable.scss")],
    controllerAs: "orderRevisionsWarningCtrl",
    bindings: {
        order: "<"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/order-revisions/order-revisions-warning.component.js
// module id = 624
// module chunks = 0